import http from "../http-common";

// used in MaterialEditBook.jsx, CreatorLlist.jsx
const getAll = () => {
  return http.get("/creators");
};

// used in MaterialAddBook.jsx
const getAllMin = () => {
  return http.get("/creators/min");
};

// used in CreatorList.jsx
const getAllDetailed = () => {
  return http.get("/creators/details");
};

// used in CreatorList.jsx
const create = (data) => {
  return http.post("/creators", data);
};

// used in CreatorCard.jsx
const update = (id, data) => {
  return http.put(`/creators/${id}`, data);
};

// used in CreatorCard.jsx
const remove = (id) => {
  return http.delete(`/creators/${id}`);
};

// used in CreatorList.jsx
const searchByName = (name) => {
  return http.get(`/creators/search/${name}`);
};

// const getNamesAndIds = () => {
//   return http.get("/creators/ids/names");
// };

// used in MaterialAddBook.jsx
const addRolesForBook = (bookId, roles) => {
  return http.post(`/books/${bookId}/creators`, roles);
};

// used in CreatorCard.jsx
const uploadMainImage = (id, data) => {
  return http.put(`/creators/${id}/mainImage`, data);
};

// used in CreatorCard.jsx
const uploadGalleryImage = (id, data) => {
  return http.put(`/creators/${id}/galleryImage`, data);
};

// used in MaterialAddBook.jsx
const getRolesForBook = (bookId) => {
  return http.get(`books/${bookId}/roles`);
};

//GET CREATORS IN DOAMIN
// used in MaterialAddBook.jsx
const getAllInDomain = (domainId) => {
  return http.get(`creators/domain/${domainId}`);
};

// used in CreatorCard.jsx
const uploadCreatorDescription = (id, data) => {
  return http.post(`/creators/${id}/description`, data);
};

// used in CreatorCard.jsx
const getCreatorDescription = (id) => {
  return http.get(`creators/${id}/description/download`);
};

// used in CreatorCard.jsx
const getCreator = (id) => {
  return http.get(`creators/${id}`);
};

// const get = (id) => {
//   return http.get(`/domains/${id}`);
// };

// const remove = (id) => {
//   return http.delete(`/domains/${id}`);
// };

// const getFields = (id) => {
//   return http.get(`/domains/${id}/fields`);
// };

// const removeField = (id) => {
//   return http.delete(`/domains/fields/${id}`);
// };

// const createField = (domainId, field) => {
//   return http.post(`/domains/${domainId}/fields`, field);
// };

// const getAllFields = () => {
//   return http.get(`/domains/fields`);
// };

// const addFieldsToDomain = (domainId, fieldIds) => {
//   return http.post(`/domains/${domainId}/fields`, fieldIds);
// };

// const getDomainName = (domainId) => {
//   return http.get(`/domains/${domainId}/name`);
// };

const CreatorService = {
  getAll,
  create,
  update,
  remove,
  searchByName,
  // getNamesAndIds,
  addRolesForBook,
  uploadMainImage,
  uploadGalleryImage,
  getRolesForBook,
  getAllMin,
  getAllInDomain,
  uploadCreatorDescription,
  getCreatorDescription,
  getCreator,
  getAllDetailed,
};

export default CreatorService;
